import {
  type FC,
  type ReactNode,
} from 'react';
import {
  Typography,
} from '@mui/joy';

export type RewardInfoTextProps = {
  rewardAmount: number;
  postfixSlot?: ReactNode;
};

export const RewardInfoText: FC<RewardInfoTextProps> = ({
  postfixSlot,
  rewardAmount,
}) => (
  <Typography sx={({ palette, breakpoints }) => ({
    fontSize: 12,
    lineHeight: 1,
    fontWeight: 600,
    color: palette.common.white,
  })}>
    {rewardAmount}
    {postfixSlot}
  </Typography>
);